import { proxy } from 'valtio';

import { CompanyProfile } from 'models';

type ProjectState = {
    profile: CompanyProfile | null;
    activeArticle: string | null;
};

const currentProfileState = proxy<ProjectState>({
    profile: null,
    activeArticle: null,
});

export { currentProfileState };
